import React, {Component, Fragment} from 'react';
import AppConfig from "../../helpers/AppConfig";
import SidebarElements from './SidebarElements';
import ClassNames from '../../enums/ClassNames';

export default class SidebarPanel extends Component {
    render() {
        return (
            <Fragment>
                <aside className="sidebar sidebar--panel d-none d-sm-flex flex-sm-column justify-content-sm-between">
                    <div className="sidebar__inner">
                        {/* Logo */}
                        <div className="sidebar__logo logo">
                            <a href="/" className="logo__link">
                                <img src={AppConfig.PowFormUrl + "/images/logo.svg"} alt="Powform logo" className="logo__img logo__img--extended" />
                                <img src={AppConfig.PowFormUrl + "/images/logo-simple.svg"} alt="Powform logo" className="logo__img logo__img--simple" />
                            </a>
                        </div>

                        <SidebarElements />
                    </div>

                    {/* Toggle sidebar */}
                    <div className="sidebar-actions">
                        <a href={AppConfig.PowFormUrl + "/help"} className="sidebar-actions__link" title="Help">
                            <svg className="icon-svg"><use href="#infoOutlined"></use></svg>
                            <span className="sidebar-actions__text">Help</span>
                        </a>

                        <a href="/" className="sidebar-actions__link sidebar-actions__link--toggle" title="Collapse Toolbar" onClick={this.toggleSidebar}>
                            <svg className="icon-svg"><use href="#pointer"></use></svg>
                            <span className="sidebar-actions__text">Collapse Toolbar</span>
                        </a>
                    </div>
                </aside>
            </Fragment>
        )
    }

    private toggleSidebar = (e: any) => {
        e.preventDefault();

        document.body.classList.toggle(ClassNames.SidebarPanelCollapsed);
    }
}